/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Price_NoteInputs */

const en_pc_cmp_price_note = /** @type {(inputs: Pc_Cmp_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acrobat prices are US list prices for individuals on adobe.com in October 2026 and vary by region.`)
};

const zh_pc_cmp_price_note = /** @type {(inputs: Pc_Cmp_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acrobat 价格为 2026 年 10 月 adobe.com 上面向个人的美国标价，各地区可能不同。`)
};

/**
* | output |
* | --- |
* | "Acrobat prices are US list prices for individuals on adobe.com in October 2026 and vary by region." |
*
* @param {Pc_Cmp_Price_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_price_note = /** @type {((inputs?: Pc_Cmp_Price_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Price_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_price_note(inputs)
	return zh_pc_cmp_price_note(inputs)
});
export { pc_cmp_price_note as "pc.cmp.price_note" }